import { ACTION_TYPES } from "../types";

export const rbuSectionItemListModule = {
  state: {
    tableOptions: {
      page: 1,
      itemsPerPage: 50,
      multiSort: false,
      sortBy: [],
      sortDesc: [],
    },
    itemMappingTableOptions: {
      page: 1,
      itemsPerPage: 50,
      multiSort: false,
      sortBy: [],
      sortDesc: [],
    },
    tab: "tab-1",
    filters: {},
    mappingFilter: {},

    rbuSectionListTableOptions: {
      page: 1,
      itemsPerPage: 50,
      multiSort: false,
      sortBy: [],
      sortDesc: [],
    },
    rbuSectionListFilter: {},
    rbuEditionListTableOptions: {
      page: 1,
      itemsPerPage: 10,
      multiSort: false,
      sortBy: [],
      sortDesc: [],
    },
    rbuEditionListFilter: {},
  },
  mutations: {
    // item
    setTableOptions(state, options) {
      state.tableOptions = options;
    },
    setFilters(state, filters) {
      state.filters = filters;
    },
    setMappingFilter(state, mappingFilter) {
      state.mappingFilter = mappingFilter;
    },
    setItemMappingTableOptions(state, options) {
      state.itemMappingTableOptions = options;
    },
    setTab(state, tab) {
      state.tab = tab;
    },

    //section
    setRbuSectionListTableOptions(state, options) {
      state.rbuSectionListTableOptions = options;
    },
    setRbuSectionListFilter(state, filter) {
      state.rbuSectionListFilter = filter;
    },

    //edition
    setRbuEditionListTableOptions(state, options) {
      state.rbuEditionListTableOptions = options;
    },
    setRbuEditionListFilter(state, filter) {
      state.rbuEditionListFilter = filter;
    },
  },
  actions: {
    // SET RBU ITEM
    [ACTION_TYPES.RBU_UPDATE_SECTION_ITEM_TABLE_OPTIONS]: {
      root: true,
      handler({ commit }, options) {
        commit("setTableOptions", options);
      },
    },
    // SET RBU ITEM MAPPING
    [ACTION_TYPES.RBU_UPDATE_SECTION_ITEM_MAPPING_OPTIONS]: {
      root: true,
      handler({ commit }, options) {
        commit("setItemMappingTableOptions", options);
      },
    },
    // SET RBU ITEM FILTER
    [ACTION_TYPES.RBU_UPDATE_SECTION_ITEM_FILTERS]: {
      root: true,
      handler({ commit }, filters) {
        commit("setFilters", filters);
      },
    },
    // SET RBU ITEM MAPPING FILTER
    [ACTION_TYPES.RBU_UPDATE_SECTION_ITEM_MAPPING_FILTER]: {
      root: true,
      handler({ commit }, filters) {
        commit("setMappingFilter", filters);
      },
    },
    // SET RBU ITEM
    [ACTION_TYPES.RBU_UPDATE_ITEM_LIST_TAB]: {
      root: true,
      handler({ commit }, tab) {
        commit("setTab", tab);
      },
    },
    // SET RBU SECTION
    [ACTION_TYPES.RBU_UPDATE_SECTION_TABLE_OPTIONS]: {
      root: true,
      handler({ commit }, options) {
        commit("setRbuSectionListTableOptions", options);
      },
    },

    // SET RBU SECTION FILTER
    [ACTION_TYPES.RBU_UPDATE_SECTION_FILTERS]: {
      root: true,
      handler({ commit }, filters) {
        commit("setRbuSectionListFilter", filters);
      },
    },

    // SET RBU EDITION
    [ACTION_TYPES.RBU_EDITION_UPDATE_ITEM_LIST_TABLE_OPTIONS]: {
      root: true,
      handler({ commit }, options) {
        commit("setRbuEditionListTableOptions", options);
      },
    },
    // SET RBU EDITION FILTER
    [ACTION_TYPES.RBU_EDITION_UPDATE_ITEM_LIST_FILTER]: {
      root: true,
      handler({ commit }, filters) {
        commit("setRbuEditionListFilter", filters);
      },
    },

    // RESET RBU ITEM
    [ACTION_TYPES.RBU_RESET_SECTION_ITEM_TABLE_OPTIONS]: {
      root: true,
      handler({ commit }) {
        commit("setTableOptions", {
          page: 1,
          itemsPerPage: 50,
          multiSort: false,
          sortBy: [],
          sortDesc: [],
        });
      },
    },

    // RESET RBU ITEM FILTER
    [ACTION_TYPES.RBU_RESET_SECTION_ITEM_FILTERS]: {
      root: true,
      handler({ commit }) {
        commit("setFilters", {});
      },
    },

    // RESET RBU ITEM MAPPING
    [ACTION_TYPES.RBU_RESET_SECTION_ITEM_MAPPING_OPTIONS]: {
      root: true,
      handler({ commit }) {
        commit("setItemMappingTableOptions", {
          page: 1,
          itemsPerPage: 50,
          multiSort: false,
          sortBy: [],
          sortDesc: [],
        });
      },
    },

    // RESET RBU ITEM MAPPING FILTER
    [ACTION_TYPES.RBU_RESET_SECTION_ITEM_MAPPING_FILTER]: {
      root: true,
      handler({ commit }) {
        commit("setMappingFilter", {});
      },
    },

    // RESET RBU ITEM TAB
    [ACTION_TYPES.RBU_RESET_ITEM_LIST_TAB]: {
      root: true,
      handler({ commit }) {
        commit("setTab", "tab-1");
      },
    },

    // RESET RBU SECTION
    [ACTION_TYPES.RBU_RESET_SECTION_TABLE_OPTIONS]: {
      root: true,
      handler({ commit }) {
        commit("setRbuSectionListTableOptions", {
          page: 1,
          itemsPerPage: 50,
          multiSort: false,
          sortBy: [],
          sortDesc: [],
        });
      },
    },

    // RESET RBU SECTION FILTER
    [ACTION_TYPES.RBU_RESET_SECTION_FILTERS]: {
      root: true,
      handler({ commit }) {
        commit("setRbuSectionListFilter", {});
      },
    },

    // RBU EDITION
    [ACTION_TYPES.RBU_EDITION_RESET_ITEM_LIST_TABLE_OPTIONS]: {
      root: true,
      handler({ commit }) {
        commit("setRbuEditionListTableOptions", {
          page: 1,
          itemsPerPage: 10,
          multiSort: false,
          sortBy: [],
          sortDesc: [],
        });
      },
    },

    // RBU EDITION FILTER
    [ACTION_TYPES.RBU_EDITION_RESET_ITEM_LIST_FILTER]: {
      root: true,
      handler({ commit }) {
        commit("setRbuEditionListFilter", {});
      },
    },

    // RESET ALL ITEM RELATED
    [ACTION_TYPES.RBU_ITEM_LIST_RESET_ALL]: {
      root: true,
      handler({ commit }) {
        commit("setTableOptions", {
          page: 1,
          itemsPerPage: 50,
          multiSort: false,
          sortBy: [],
          sortDesc: [],
        });
        commit("setItemMappingTableOptions", {
          page: 1,
          itemsPerPage: 50,
          multiSort: false,
          sortBy: [],
          sortDesc: [],
        });
        commit("setFilters", {});
        commit("setMappingFilter", {});
        commit("setTab", "tab-1");
      },
    },
  },
  getters: {
    getSectionItemTableOptions: (state) => state.tableOptions,
    getSectionItemFilters: (state) => state.filters,
    getSectionItemMappingTableOptions: (state) => state.itemMappingTableOptions,
    getItemListMappingFilter: (state) => state.mappingFilter,
    getItemListTab: (state) => state.tab,
    getRbuSectionListTableOptions: (state) => state.rbuSectionListTableOptions,
    getRbuSectionListFilter: (state) => state.rbuSectionListFilter,
    getRbuEditionListTableOptions: (state) => state.rbuEditionListTableOptions,
    getRbuEditionListFilter: (state) => state.rbuEditionListFilter,
  },
};
